import { combineReducers } from "redux";
import registration from "../features/admin/auth/Slice";

const autho = combineReducers({
  registration: registration,
});

export default autho;
